module.exports = __webpack_public_path__ + "img/contact5.da5f0671.png";